const palettes = [
  {
    primary: "#4A4FC7",
    secondary: "#797B96",
    accent: "#fff",
  },
  {
    primary: "#EB546F",
    secondary: "#220257",
    accent: "#FFFFFF",
  },
  {
    primary: "#173d4e",
    secondary: "#34af9e",
    accent: "#e1f1f1",
  },
  {
    primary: "#e74c3c",
    secondary: "#2c3e50",
    accent: "#f2f3f4",
  },
  {
    primary: "#6c8569",
    secondary: "#97a58a",
    accent: "#F7FFE5",
  },
  {
    primary: "#3AA6B9",
    secondary: "#81a39d",
    accent: "#f6fffd",
  },
  {
    primary: "#001C30",
    secondary: "#176B87",
    accent: "#f5fefe",
  },
  {
    primary: "#FF6666",
    secondary: "#FF8989",
    accent: "#fff8f3",
  },
  {
    primary: "#3F2305",
    secondary: "#b4ae9b",
    accent: "#F5F5F5",
  },
  {
    primary: "#4A55A2",
    secondary: "#7895CB",
    accent: "#ecf6ff",
  },
  {
    primary: "#A63E44",
    secondary: "#966D62",
    accent: "#FDFDFD",
  },
  {
    primary: "#2C3B50",
    secondary: "#648CB2",
    accent: "#F3F6F9",
  },
  {
    primary: "#C47A2D",
    secondary: "#7B997F",
    accent: "#FDFBEF",
  },
  {
    primary: "#4E9C6A",
    secondary: "#EEA53C",
    accent: "#F9F4EB",
  },
  {
    primary: "#6D1D54",
    secondary: "#A63E6D",
    accent: "#F8F4F8",
  },
  {
    primary: "#A67239",
    secondary: "#5B776B",
    accent: "#FEF9F2",
  },
  {
    primary: "#2C4868",
    secondary: "#4A89C1",
    accent: "#F5F9FD",
  },
  {
    primary: "#8C6266",
    secondary: "#D8A18D",
    accent: "#FAF7F7",
  },
  {
    primary: "#8A282A",
    secondary: "#C24B4D",
    accent: "#FDF9F9",
  },
  {
    primary: "#3C3550",
    secondary: "#7D8AB0",
    accent: "#F7F7FB",
  },
  {
    primary: "#8E6E1E",
    secondary: "#C7A542",
    accent: "#FAF8EC",
  },
  {
    primary: "#B32824",
    secondary: "#52656F",
    accent: "#F8F9FA",
  },
  {
    primary: "#3C1E4F",
    secondary: "#9658A1",
    accent: "#F7F2FA",
  },
  {
    primary: "#7A3C38",
    secondary: "#B9827B",
    accent: "#FFF5F5",
  },
];

export default palettes;
